import { waLink, WHATSAPP_NUMBER } from "../lib/whatsapp";

const LOGO = "https://martins-e-freitas-v2.vercel.app/logo.svg";

export const Footer = () => (
  <footer className="bg-ink text-cream" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
      <div>
        <img src={LOGO} alt="Martins e Freitas" className="h-9 w-auto mb-5 brightness-0 invert" />
        <p className="text-sm text-cream/60 max-w-xs leading-relaxed">
          Advocacia trabalhista com atendimento direto, humano e estratégico.
        </p>
      </div>

      <div className="flex flex-col gap-3">
        <span className="font-mono text-xs uppercase tracking-[0.2em] text-cream/40 mb-2">
          Navegação
        </span>
        {[
          { href: "#quem-somos", label: "Quem somos" },
          { href: "#servicos", label: "Serviços" },
          { href: "#como-funciona", label: "Como funciona" },
          { href: "#faq", label: "FAQ" },
        ].map((l) => (
          <a
            key={l.href}
            href={l.href}
            className="text-sm text-cream/70 hover:text-cream transition-colors duration-300 w-fit"
            data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
          >
            {l.label}
          </a>
        ))}
      </div>

      <div className="flex flex-col gap-3">
        <span className="font-mono text-xs uppercase tracking-[0.2em] text-cream/40 mb-2">
          Contato
        </span>
        <a
          href={waLink()}
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm text-cream/70 hover:text-cream transition-colors duration-300 w-fit"
          data-testid="footer-whatsapp-link"
        >
          WhatsApp {WHATSAPP_NUMBER.replace("55", "+55 ").replace(/(\d{2})(\d{5})(\d{4})/, "$1 $2-$3")}
        </a>
        <span className="text-sm text-cream/50">Rio de Janeiro, RJ</span>
      </div>
    </div>

    <div className="border-t border-cream/10 px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-2 max-w-7xl mx-auto">
      <span className="font-mono text-[11px] text-cream/40 tracking-wide">
        © 2026 Martins e Freitas Advogados Associados
      </span>
      <span className="font-mono text-[11px] text-cream/40 tracking-wide">
        Advocacia Trabalhista
      </span>
    </div>
  </footer>
);
